<template>
    <form class="login login--password-email" v-bind:action="apiUrl + '/password/email'" v-on:submit.prevent="handleSubmit">
        <h3 class="has-margin-b30">{{ __('Reset Password') }}</h3>

        <div class="form__group" v-bind:class="{ 'has-error' : errors.email }">
            <label class="form__label" for="email">{{ __('Email') }}</label>
            <input class="form__control is-large dark-color" id="email" type="email" autocomplete="off" placeholder="Your email here"
                   v-model="email"
            />
        </div>
        <small class="form__error" v-if="errors.email">{{ errors.email[0] }}</small>

        <div class="form__success" v-if="!errors.email && success">
            {{ __('We have e-mailed your password reset link!') }}
        </div>

        <button class="btn is-full-width is-primary has-margin-t30 is-loading" type="submit"><span class="btn__loader" v-if="showLoader"></span>{{ __('Send Password Reset Link') }}</button>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        data: function () {
            return {
                email: '',
                errors: {},
                showLoader: false,
                success: false
            }
        },
        methods: {
            handleSubmit: function (e) {
                this.showLoader = true;

                const form = e.target;
                const action = form.getAttribute('action');

                this.$http.post(action, {
                    email: this.email
                }).then(function (response) {
                    this.success = true;
                    eventBus.$emit('show-alert', 'success', this.__('We have e-mailed your password reset link!'));

                    this.showLoader = false;
                }.bind(this), function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    this.showLoader = false;
                }.bind(this));
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/PasswordEmailSidebar.vue